import React from 'react';
import { AlertCircle } from 'lucide-react';
import styled from 'styled-components';

export const WelcomeCardContainer = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
`;

export const WelcomeCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const WelcomeContent = styled.div``;

export const WelcomeTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
`;

export const WelcomeSubtitle = styled.p`
  color: #6b7280;
`;

export const AlertBadge = styled.div`
  display: flex;
  align-items: center;
  background-color: #fee2e2;
  color: #dc2626;
  padding: 0.5rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  
  svg {
    margin-right: 0.5rem;
  }
`;

interface WelcomeCardProps {
  teacherName: string;
  term: string;
  alertCount: number;
}

const WelcomeCard: React.FC<WelcomeCardProps> = ({ teacherName, term, alertCount }) => {
  return (
    <WelcomeCardContainer>
      <WelcomeCardHeader>
        <WelcomeContent>
          <WelcomeTitle>Welcome back, {teacherName}!</WelcomeTitle>
          <WelcomeSubtitle>
            Here's an overview of your teaching dashboard for {term}
          </WelcomeSubtitle>
        </WelcomeContent>
        {alertCount > 0 && (
          <AlertBadge>
            <AlertCircle size={16} />
            <span>{alertCount} alerts</span>
          </AlertBadge>
        )}
      </WelcomeCardHeader>
    </WelcomeCardContainer>
  );
};

export default WelcomeCard; 